var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOld
    ? _c(
        "div",
        { staticClass: "formCreate" },
        [
          _c("form-create", {
            staticClass: "form-create",
            attrs: { rule: _vm.rule, option: _vm.option },
            model: {
              value: _vm.fApi,
              callback: function($$v) {
                _vm.fApi = $$v
              },
              expression: "fApi"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _vm.showSave
                ? _c(
                    "Button",
                    {
                      staticClass: "keep",
                      attrs: { disabled: _vm.isCancel },
                      on: { click: _vm.preserveBtn }
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showSubmit
                ? _c(
                    "Button",
                    {
                      attrs: { disabled: _vm.isCancel, type: "primary" },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showBtn,
                expression: "showBtn"
              }
            ],
            staticStyle: { "padding-bottom": "50px" }
          })
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "formCreate" },
        [
          _vm.moduleListUpload.length
            ? _c("ul", { staticClass: "data-steps" }, [
                _c("li", { staticClass: "ds-icon ds-current" }, [
                  _c(
                    "span",
                    [
                      _vm.stepsIndex > 1
                        ? _c("a-icon", { attrs: { type: "check" } })
                        : _c("span", [_vm._v("1")])
                    ],
                    1
                  ),
                  _vm._v("准备资料\n    ")
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass: "ds-icon",
                    class: { "ds-current": _vm.stepsIndex > 1 }
                  },
                  [
                    _c(
                      "span",
                      [
                        _vm.stepsIndex > 2
                          ? _c("a-icon", { attrs: { type: "check" } })
                          : _c("span", [_vm._v("2")])
                      ],
                      1
                    ),
                    _vm._v("填写资料\n    ")
                  ]
                ),
                _vm._v(" "),
                _c("li", { class: { "ds-current": _vm.stepsIndex == 3 } }, [
                  _c("span", [_vm._v("3")]),
                  _vm._v("预览提交")
                ])
              ])
            : _vm.moduleList.length
            ? _c("ul", { staticClass: "data-steps" }, [
                _c("li", { staticClass: "ds-icon ds-current" }, [
                  _c(
                    "span",
                    [
                      _vm.stepsIndex > 2
                        ? _c("a-icon", { attrs: { type: "check" } })
                        : _c("span", [_vm._v("1")])
                    ],
                    1
                  ),
                  _vm._v("填写资料\n    ")
                ]),
                _vm._v(" "),
                _c("li", { class: { "ds-current": _vm.stepsIndex == 3 } }, [
                  _c("span", [_vm._v("2")]),
                  _vm._v("预览提交")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.rejectInfo !== ""
            ? _c(
                "div",
                { staticClass: "rejectinfo" },
                [
                  _c("Icon", {
                    staticStyle: { color: "#E34D59" },
                    attrs: { type: "md-alert" }
                  }),
                  _vm._v("驳回原因:" + _vm._s(_vm.rejectInfo) + "\n  ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.stepsIndex == 1
            ? _c("DataPreparation", {
                attrs: {
                  moduleListUpload: _vm.moduleListUpload,
                  serviceInfo: _vm.serviceInfo,
                  moduleListUploadSelect: _vm.moduleListUploadSelect
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.stepsIndex == 3
            ? _c("DataPreviews", {
                attrs: {
                  workOrderId: _vm.workOrderId,
                  tabsCurrent: _vm.tabsCurrent,
                  showSubmit: _vm.showSubmit
                },
                on: { nextStep: _vm.nextStep }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-create-wrap" },
            [
              _c(
                "div",
                { staticClass: "form-create-anchor" },
                [
                  _c(
                    "a-anchor",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.stepsIndex == 2,
                          expression: "stepsIndex == 2"
                        }
                      ],
                      attrs: { "target-offset": 50 }
                    },
                    _vm._l(_vm.moduleList, function(item) {
                      return _c("a-anchor-link", {
                        key: item.moduleId,
                        attrs: {
                          href: "#" + item.moduleName,
                          title: item.moduleName
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("form-create", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.stepsIndex == 2,
                    expression: "stepsIndex == 2"
                  }
                ],
                staticClass: "form-create form-create-new",
                attrs: { rule: _vm.rule, option: _vm.option },
                model: {
                  value: _vm.fApi,
                  callback: function($$v) {
                    _vm.fApi = $$v
                  },
                  expression: "fApi"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _vm.stepsIndex == 1
                ? _c(
                    "Button",
                    {
                      staticClass: "keep",
                      on: {
                        click: function($event) {
                          return _vm.$router.go(-1)
                        }
                      }
                    },
                    [_vm._v("取消")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.stepsIndex == 1
                ? _c(
                    "Button",
                    {
                      attrs: { disabled: _vm.isCancel, type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.nextStep(2, true)
                        }
                      }
                    },
                    [_vm._v("下一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.stepsIndex > 1 &&
              _vm.moduleListUpload.length &&
              _vm.showSubmit
                ? _c(
                    "Button",
                    {
                      staticClass: "keep",
                      attrs: { disabled: _vm.isCancel },
                      on: {
                        click: function($event) {
                          return _vm.nextStep(_vm.stepsIndex - 1)
                        }
                      }
                    },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.stepsIndex > 1 && _vm.showSave
                ? _c(
                    "Button",
                    {
                      staticClass: "keep",
                      attrs: { disabled: _vm.isCancel },
                      on: { click: _vm.preserveBtn }
                    },
                    [_vm._v("暂存")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showSubmit && _vm.stepsIndex == 3
                ? _c(
                    "Button",
                    {
                      attrs: { disabled: _vm.isCancel, type: "primary" },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("提交")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.stepsIndex == 2
                ? _c(
                    "Button",
                    {
                      attrs: { disabled: _vm.isCancel, type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.nextStep(3)
                        }
                      }
                    },
                    [_vm._v("下一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.showSubmit && _vm.stepsIndex == 3
                ? _c(
                    "Button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.$router.go(-1)
                        }
                      }
                    },
                    [_vm._v("返回")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showBtn,
                expression: "showBtn"
              }
            ],
            staticStyle: { "padding-bottom": "50px" }
          }),
          _vm._v(" "),
          _vm.assistantShow
            ? _c(
                "div",
                {
                  directives: [{ name: "drag", rawName: "v-drag" }],
                  ref: "assistantRef",
                  staticClass: "assistant-tips"
                },
                [
                  _c(
                    "a-popconfirm",
                    {
                      attrs: {
                        "ok-text": "继续关闭",
                        "cancel-text": "取消",
                        width: "120"
                      },
                      on: {
                        confirm: function($event) {
                          _vm.assistantShow = false
                        }
                      }
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _c("p", { staticClass: "assistant-close-tips" }, [
                          _vm._v(
                            "暂时关闭小助手后，再次点击输入框就可以唤起小助手拉"
                          )
                        ])
                      ]),
                      _c("a-icon", {
                        staticClass: "drag-close-icon",
                        attrs: { type: "close" }
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("dl", [
                    _c("dt", [_vm._v(_vm._s(_vm.assistantInfo.keyLabel))]),
                    _vm._v(" "),
                    _vm.assistantInfo.keyName == "marketHref"
                      ? _c("dd", { staticClass: "diy-tips remind-message" }, [
                          _c("div", [
                            _vm._v(_vm._s(_vm.assistantInfo.remindMessage))
                          ]),
                          _vm._v(" "),
                          _c("div", [_vm._v("销售链接要求：")]),
                          _vm._v("\n        1、在美国境内销售，币种为美元;"),
                          _c("br"),
                          _vm._v(
                            "\n        2、可加入购物车，销售金额与市场价保持一致，上下浮动20%的范围比较合理;"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n        3、至少有一张产品图显示出商标名字;"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n        4、标题首位是商标名称或者品牌是商标名字;"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n        5、链接可以是亚马逊/eBay/Wish/阿里巴巴国际站等。"
                          ),
                          _c("br")
                        ])
                      : _vm.assistantInfo.keyName == "trademarkCategory"
                      ? _c("dd", { staticClass: "diy-tips remind-message" }, [
                          _vm._v(
                            "\n        小类信息由专员在官网进行排查，最终以官网信息为准.建议最佳是10-15个商标小类名称,最多20个\n      "
                          )
                        ])
                      : _vm.assistantInfo.keyName == "useProductImg"
                      ? _c("dd", { staticClass: "diy-tips remind-message" }, [
                          _c("div", [_vm._v("使用证据要求：")]),
                          _vm._v(
                            "\n        1、照片必须为 JPG 格式、每张图≤2MB; 照片清晰且无水印、产品完整且未使用过;"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n        2、照片不可经过 PS、美化等处理，产品要真正的实拍图，不要白底图片，不要拍到 其他杂物，也不要手拿着拍;"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n        3、照片请以小类英文名称命名，方便审核;"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n        4、商标LOGO 不能采用贴纸、金属贴标等方式，需要真实印，可采用丝印、镭射、激 光、雕刻;"
                          ),
                          _c("br"),
                          _vm._v(
                            "\n        5、产品图上不能出现中文以及™、®标识。"
                          ),
                          _c("br"),
                          _vm._v(" "),
                          _vm._m(0),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _vm._m(2)
                        ])
                      : _c("dd", { staticClass: "remind-message" }, [
                          _vm._v(_vm._s(_vm.assistantInfo.remindMessage))
                        ]),
                    _vm._v(" "),
                    _c("dd", [
                      _vm.assistantInfo.fileModelUrl
                        ? _c(
                            "a",
                            {
                              staticStyle: {
                                color: "#16ade9",
                                "margin-right": "20px"
                              },
                              attrs: {
                                href: _vm.assistantInfo.fileModelUrl,
                                target: "_blank"
                              }
                            },
                            [
                              _vm.assistantInfo.fileModelUrl.includes("png") ||
                              _vm.assistantInfo.fileModelUrl.includes("jpg") ||
                              _vm.assistantInfo.fileModelUrl.includes("jpeg")
                                ? _c("img", {
                                    staticClass: "fileModel",
                                    attrs: {
                                      src: _vm.assistantInfo.fileModelUrl
                                    }
                                  })
                                : _c(
                                    "div",
                                    { staticClass: "fileModel-other" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.fileModelUrlSuffix(
                                            _vm.assistantInfo.fileModelUrl
                                          )
                                        )
                                      )
                                    ]
                                  )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(3)
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "Modal",
            {
              staticClass: "automatic-recognition-modal antd-style-modal",
              attrs: {
                title: _vm.automaticTitle[_vm.automaticType] + "上传成功",
                "ok-text": "自动填写",
                width: "700"
              },
              on: {
                "on-ok": _vm.automaticOk,
                "on-cancel": _vm.automaticCancel
              },
              model: {
                value: _vm.automaticRecognitionModal,
                callback: function($$v) {
                  _vm.automaticRecognitionModal = $$v
                },
                expression: "automaticRecognitionModal"
              }
            },
            [
              _c("div", { staticClass: "automatic-recognition-tips" }, [
                _vm._v("\n      识别到以下信息，是否自动完成填写\n      "),
                _c("p", [
                  _vm._v("识别成功，如果有问题，鼠标悬停在内容上即可修改")
                ])
              ]),
              _vm._v(" "),
              _c(
                "dl",
                { staticClass: "identify-content" },
                [
                  _vm.automaticValuable
                    ? _c("dt", [_vm._v("识别内容")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.automaticType == "COMPANY_LICENSE"
                    ? [
                        _c(
                          "dd",
                          [
                            _c("span", [_vm._v("营业执照号：")]),
                            _c("Input", {
                              model: {
                                value:
                                  _vm.businessLicenseInfo.businessLicenseNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.businessLicenseInfo,
                                    "businessLicenseNumber",
                                    $$v
                                  )
                                },
                                expression:
                                  "businessLicenseInfo.businessLicenseNumber"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "dd",
                          [
                            _c("span", [_vm._v("公司名称：")]),
                            _c("Input", {
                              model: {
                                value: _vm.businessLicenseInfo.companyNameZh,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.businessLicenseInfo,
                                    "companyNameZh",
                                    $$v
                                  )
                                },
                                expression: "businessLicenseInfo.companyNameZh"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "dd",
                          [
                            _c("span", [_vm._v("经营地址：")]),
                            _c("Input", {
                              model: {
                                value:
                                  _vm.businessLicenseInfo.addressOfBusiness,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.businessLicenseInfo,
                                    "addressOfBusiness",
                                    $$v
                                  )
                                },
                                expression:
                                  "businessLicenseInfo.addressOfBusiness"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "dd",
                          [
                            _c("span", [_vm._v("法定代表人：")]),
                            _c("Input", {
                              model: {
                                value:
                                  _vm.businessLicenseInfo.companyLegalPersonCh,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.businessLicenseInfo,
                                    "companyLegalPersonCh",
                                    $$v
                                  )
                                },
                                expression:
                                  "businessLicenseInfo.companyLegalPersonCh"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "dd",
                          [
                            _c("span", [_vm._v("注册日期：")]),
                            _c("Input", {
                              model: {
                                value:
                                  _vm.businessLicenseInfo.dateOfRegistration,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.businessLicenseInfo,
                                    "dateOfRegistration",
                                    $$v
                                  )
                                },
                                expression:
                                  "businessLicenseInfo.dateOfRegistration"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.automaticType == "ID_CARD"
                    ? [
                        _c(
                          "dd",
                          [
                            _c("span", [_vm._v("证件持有人姓名：")]),
                            _c("Input", {
                              model: {
                                value: _vm.idCardInfo.nameOfCertificateHolder,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.idCardInfo,
                                    "nameOfCertificateHolder",
                                    $$v
                                  )
                                },
                                expression: "idCardInfo.nameOfCertificateHolder"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "dd",
                          [
                            _c("span", [_vm._v("证件号码：")]),
                            _c("Input", {
                              model: {
                                value: _vm.idCardInfo.documentNumber,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.idCardInfo,
                                    "documentNumber",
                                    $$v
                                  )
                                },
                                expression: "idCardInfo.documentNumber"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "dd",
                          [
                            _c("span", [_vm._v("证件持有人住址：")]),
                            _c("Input", {
                              model: {
                                value: _vm.idCardInfo.addressOfDocumentHolder,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.idCardInfo,
                                    "addressOfDocumentHolder",
                                    $$v
                                  )
                                },
                                expression: "idCardInfo.addressOfDocumentHolder"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.automaticType == "ID_CARD_REVERSE"
                    ? [
                        _c(
                          "dd",
                          [
                            _c("span", [_vm._v("证件有效期：")]),
                            _c("Input", {
                              model: {
                                value:
                                  _vm.idCardReverseInfo
                                    .validityPeriodOfCertificate,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.idCardReverseInfo,
                                    "validityPeriodOfCertificate",
                                    $$v
                                  )
                                },
                                expression:
                                  "idCardReverseInfo.validityPeriodOfCertificate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.automaticValuable
                ? _c("dl", { staticClass: "current-content" }, [
                    _c("dt", [_vm._v("当前内容")]),
                    _vm._v(" "),
                    _vm.automaticType == "COMPANY_LICENSE" &&
                    _vm.businessLicenseInfoCurrent.BusinessLicenseNumber
                      ? _c("dd", [
                          _c("span", [_vm._v("营业执照号：")]),
                          _vm._v(
                            _vm._s(
                              _vm.businessLicenseInfoCurrent
                                .BusinessLicenseNumber
                            ) + "\n      "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.automaticType == "COMPANY_LICENSE" &&
                    _vm.businessLicenseInfoCurrent.companyNameZh
                      ? _c("dd", [
                          _c("span", [_vm._v("公司名称：")]),
                          _vm._v(
                            _vm._s(
                              _vm.businessLicenseInfoCurrent.companyNameZh
                            ) + "\n      "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.automaticType == "COMPANY_LICENSE" &&
                    _vm.businessLicenseInfoCurrent.AddressOfBusiness
                      ? _c("dd", [
                          _c("span", [_vm._v("经营地址：")]),
                          _vm._v(
                            _vm._s(
                              _vm.businessLicenseInfoCurrent.AddressOfBusiness
                            ) + "\n      "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.automaticType == "COMPANY_LICENSE" &&
                    _vm.businessLicenseInfoCurrent.companyLegalPersonCh
                      ? _c("dd", [
                          _c("span", [_vm._v("法定代表人：")]),
                          _vm._v(
                            _vm._s(
                              _vm.businessLicenseInfoCurrent
                                .companyLegalPersonCh
                            ) + "\n      "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.automaticType == "COMPANY_LICENSE" &&
                    _vm.businessLicenseInfoCurrent.DateOfRegistration
                      ? _c("dd", [
                          _c("span", [_vm._v("注册日期：")]),
                          _vm._v(
                            _vm._s(
                              _vm.businessLicenseInfoCurrent.DateOfRegistration
                            ) + "\n      "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.automaticType == "ID_CARD_REVERSE" &&
                    _vm.idCardReverseInfoCurrent.ValidityPeriodOfCertificate
                      ? _c("dd", [
                          _c("span", [_vm._v("证件有效期：")]),
                          _vm._v(
                            _vm._s(
                              _vm.idCardReverseInfoCurrent
                                .ValidityPeriodOfCertificate
                            ) + "\n      "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.automaticType == "ID_CARD" &&
                    _vm.idCardInfoCurrent.NameOfCertificateHolder
                      ? _c("dd", [
                          _c("span", [_vm._v("证件持有人姓名：")]),
                          _vm._v(
                            _vm._s(
                              _vm.idCardInfoCurrent.NameOfCertificateHolder
                            ) + "\n      "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.automaticType == "ID_CARD" &&
                    _vm.idCardInfoCurrent.DocumentNumber
                      ? _c("dd", [
                          _c("span", [_vm._v("证件号码：")]),
                          _vm._v(
                            _vm._s(_vm.idCardInfoCurrent.DocumentNumber) +
                              "\n      "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.automaticType == "ID_CARD" &&
                    _vm.idCardInfoCurrent.AddressOfDocumentHolder
                      ? _c("dd", [
                          _c("span", [_vm._v("证件持有人住址：")]),
                          _vm._v(
                            _vm._s(
                              _vm.idCardInfoCurrent.AddressOfDocumentHolder
                            ) + "\n      "
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "Modal",
            {
              staticClass: "import-templates-modal antd-style-modal",
              attrs: { title: "用模板导入", width: "634" },
              on: {
                "on-ok": _vm.importTemplatesOk,
                "on-cancel": _vm.importTemplatesCancel
              },
              model: {
                value: _vm.importTemplatesModal,
                callback: function($$v) {
                  _vm.importTemplatesModal = $$v
                },
                expression: "importTemplatesModal"
              }
            },
            [
              _c(
                "div",
                { staticClass: "import-templates-info" },
                [
                  _c("h2", { staticClass: "import-templates-title" }, [
                    _c("b", [_vm._v("1")]),
                    _vm._v("下载信息表，填写内容")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "import-templates-desc" }, [
                    _vm._v(
                      "请按照模板的格式填写服务资料，模板中的表头名称不可更改，表头不能删除。"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "Button",
                    { on: { click: _vm.downloadHandle } },
                    [
                      _c("a-icon", {
                        staticClass: "mr-8",
                        attrs: { type: "download" }
                      }),
                      _vm._v("下载")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "import-templates-info" },
                [
                  _c("h2", { staticClass: "import-templates-title" }, [
                    _c("b", [_vm._v("2")]),
                    _vm._v("上传填写好的信息表")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "import-templates-desc" }, [
                    _vm._v(
                      "请按照模板填写信息后再上传，需请勿上传压缩包，格式限制为：xlsx、xls。"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "Upload",
                    {
                      staticClass: "upload-box",
                      attrs: {
                        "max-size": 30 * 1024,
                        "before-upload": _vm.beforeUploadAccept,
                        action: ""
                      }
                    },
                    [
                      _c(
                        "Button",
                        { attrs: { type: "primary" } },
                        [
                          _c("a-icon", {
                            staticClass: "mr-8",
                            attrs: { type: "upload" }
                          }),
                          _vm._v("上传")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.uploadFileName
                    ? _c(
                        "span",
                        { staticClass: "upload-file-name" },
                        [
                          _c("a-icon", { attrs: { type: "paper-clip" } }),
                          _vm._v(_vm._s(_vm.uploadFileName)),
                          _vm.uploadFileName
                            ? _c("a-icon", {
                                attrs: { type: "delete" },
                                on: {
                                  click: function($event) {
                                    _vm.uploadFileName = ""
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "import-templates-desc" }, [
                _vm._v(
                  "\n      上传结束后系统将自动匹配信息，请再次确认和修改信息吧，最终提交且审核通过后，不支持修改和退款哦。\n    "
                )
              ])
            ]
          )
        ],
        1
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "examples" }, [
      _c("p", [_vm._v("符合的图片类型")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "https://file.cjtglobal.com/group1/M00/04/EE/rBLKNV_QkQuAF2JiAACSFlBcrYk905.png",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "https://file.cjtglobal.com/group1/M00/04/EE/rBLKNV_QkSqAfwZfAAClUBVsIrc431.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "examples" }, [
      _c("p", [_vm._v("不符合的图片类型")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "https://file.cjtglobal.com/group1/M00/04/EE/rBLKNV_QkUKAE8BbAACOuG7i62g495.png",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "https://file.cjtglobal.com/group1/M00/04/EE/rBLKNV_QkVqAYciLAACc2vOyxb4242.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "modal-tip" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/product/error-icon.png"),
          alt: ""
        }
      }),
      _vm._v(
        "不符合原因：1、产品不完整 2、没有logo 3、含有中文\n          4、图片不清晰\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "customer-service" }, [
      _c("div", { staticClass: "customer-service-txt" }, [
        _vm._v("\n        挡住视线可以我把拖走呦\n        ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-524141b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-524141b7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/dynamicForm.vue
// module id = null
// module chunks = 